<div class="multi-slide-action" *ngIf="liveView && slides.length > 1">
  <div>
    {{'meetings.Pathology Slides' | translate}} <span class="badge">{{slides.length}}</span>
  </div>
  <div>
    <button class="btn customBtn" matRipple (click)="openMultiSlideSelect = true">
      {{'meetings.View Multiple Slides' | translate}}</button>
  </div>
</div>

<app-view-multi-slide
  *ngIf="openMultiSlideSelect && liveView"
  [slides]="slides"
  (cancelPop)='openSlidesViewer($event)'
></app-view-multi-slide>

<div class="slides-list" *ngIf="slides.length">
  <div class="slide-card" *ngFor="let slide of slides; index as i">
    <div class="head">
      <div class="slide-num">{{ 'meetings.Slide No.' | translate }} {{i+1}}</div>
      <div>
        <a (click)="openSlidesViewer([slide.id])"
          class="btn px-1" *ngIf="liveView">
          <svg class="m-0" height="13" viewBox="0 0 20 13" width="20"><path d="M5612.231,13468.172a1.087,1.087,0,0,1,0-1.345c1.088-1.367,4.972-5.828,9.767-5.828s8.679,4.461,9.767,5.828a1.087,1.087,0,0,1,0,1.345c-1.088,1.367-4.972,5.827-9.767,5.827S5613.319,13469.539,5612.231,13468.172Zm5.105-.673a4.662,4.662,0,1,0,4.662-4.706A4.685,4.685,0,0,0,5617.336,13467.5Zm1.443,0a3.219,3.219,0,1,1,3.219,3.25A3.238,3.238,0,0,1,5618.779,13467.5Zm1.177-.224h1.065a.742.742,0,0,1,.732-.739v-1.076A1.828,1.828,0,0,0,5619.956,13467.275Z" fill="#92bcd2" id="view-icon" transform="translate(-5611.998 -13460.999)"></path></svg></a>

        <div class="tableOptions-container" [hidden]="liveView" *ngIf="slide.canEdit">
          <button class="btn btn-outline-primary p-0" [matMenuTriggerFor]="menu">
            <svg width="24" height="6" viewBox="0 0 24 6" class="m-0">
              <path id="show-actions-menu-btn" d="M5610.879,13616.122a3,3,0,1,1,2.121.879A3,3,0,0,1,5610.879,13616.122Zm-9,0a3,3,0,1,1,2.121.879A3,3,0,0,1,5601.878,13616.122Zm-9,0a3,3,0,1,1,2.121.879A3,3,0,0,1,5592.878,13616.122Z" transform="translate(-5592 -13611.001)" fill="#666" />
            </svg>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="unlinkSlide(slide.id)">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17">
                <path id="unlink" d="M88.546-819.136l-1.338-1.39a2.721,2.721,0,0,0,1.45-.953,2.583,2.583,0,0,0,.558-1.648,2.6,2.6,0,0,0-.781-1.906,2.574,2.574,0,0,0-1.9-.785H83.862a.861.861,0,0,1-.636-.258.87.87,0,0,1-.257-.639.871.871,0,0,1,.257-.639.861.861,0,0,1,.636-.258h2.677A4.288,4.288,0,0,1,89.7-826.3a4.335,4.335,0,0,1,1.3,3.174,4.431,4.431,0,0,1-.658,2.355A4.28,4.28,0,0,1,88.546-819.136Zm-3.234-3.3-1.584-1.592h1.026a.861.861,0,0,1,.636.258.871.871,0,0,1,.257.639.894.894,0,0,1-.089.4A.78.78,0,0,1,85.312-822.433Zm4.349,8.186a.843.843,0,0,1-.625.247.843.843,0,0,1-.625-.247L73.245-829.5a.853.853,0,0,1-.245-.628.853.853,0,0,1,.245-.628A.843.843,0,0,1,73.87-831a.844.844,0,0,1,.625.247L89.662-815.5a.853.853,0,0,1,.245.628A.853.853,0,0,1,89.662-814.247Zm-12.045-4.4a4.288,4.288,0,0,1-3.156-1.312,4.335,4.335,0,0,1-1.3-3.173,4.389,4.389,0,0,1,.937-2.759,4.346,4.346,0,0,1,2.409-1.592l1.651,1.66h-.535a2.574,2.574,0,0,0-1.9.785,2.6,2.6,0,0,0-.781,1.906,2.6,2.6,0,0,0,.781,1.906,2.574,2.574,0,0,0,1.9.785h2.677a.861.861,0,0,1,.636.258.87.87,0,0,1,.257.639.87.87,0,0,1-.257.639.861.861,0,0,1-.636.258Zm1.784-3.588a.861.861,0,0,1-.636-.258.87.87,0,0,1-.257-.639.871.871,0,0,1,.257-.639.861.861,0,0,1,.636-.258h.558l1.762,1.794Z" transform="translate(-73 831)" fill="#92bcd2"/>
              </svg>
              <span>{{ 'meetings.Unlink' | translate }}</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="slide-info">
      <div class="row">
        <div class="col-md-6">
          <label>{{'meetings.Subspecialty' | translate}}</label>
          <div>{{slide.subspeciality.name || notFound}}</div>
        </div>
        <div class="col-md-6">
          <label>{{'meetings.Tissue type' | translate}}</label>
          <div>{{slide.tissueType.name || notFound}}</div>
        </div>
        <div class="col-md-6">
          <label>{{'meetings.Specimen Source' | translate}}</label>
          <div>{{slide.specimenSource.specimenSourceName || notFound}}</div>
        </div>
        <div class="col-md-6">
          <label>{{'meetings.Stain type' | translate}}</label>
          <div>{{slide.stainType.name || notFound}}</div>
        </div>

        <div class="col-md-6" *ngIf="!agendaItemId">
          <label>{{'meetings.Related agenda item' | translate}}</label>
          <div>{{slide.relatedAgendaItem ? slide.relatedAgendaItem.name : notFound}}</div>
        </div>

      </div>
    </div>
  </div>
</div>
